var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tabs',{staticClass:"tabs m-b-15"},[_c('TabPane',{attrs:{"label":"Activity"}},[(_vm.pitch.id)?_c('activity-viewer',{attrs:{"subjectId":_vm.pitch.id,"subjectType":"pitch"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }